<modal-panel title="Filter TMT ERP Outbound Report" (close)="close()">
  <div class="filter" [formGroup]="form">
    <div class="filter__fields" [class.two-col]="!isSmall">

      <mat-form-field data-testid="tmt-erp-outbound-filter-modal-erp-sales-order-number-field">
        <mat-label data-testid="tmt-erp-outbound-filter-modal-erp-sales-order-number-field-label">ERP Sales Order No.</mat-label>
        <input matInput formControlName="ErpOrderNumber" placeholder="e.g. SO-000123" data-testid="tmt-erp-outbound-filter-modal-erp-sales-order-number-field-input"/>
      </mat-form-field>

      <mat-form-field data-testid="tmt-erp-outbound-filter-modal-sales-order-sync-queue-id-field">
        <mat-label data-testid="tmt-erp-outbound-filter-modal-sales-order-sync-queue-id-field-label">Sync Queue ID</mat-label>
        <input matInput formControlName="SalesOrderSyncQueueId" placeholder="e.g. 123" data-testid="tmt-erp-outbound-filter-modal-sales-order-sync-queue-id-field-input"/>
      </mat-form-field>

      <mat-form-field data-testid="tmt-erp-outbound-filter-modal-invoice-number-field">
        <mat-label data-testid="tmt-erp-outbound-filter-modal-invoice-number-field-label">ERP Invoice No.</mat-label>
        <input matInput formControlName="InvoiceNumber" placeholder="e.g. INV-000123" data-testid="tmt-erp-outbound-filter-modal-invoice-number-field-input"/>
      </mat-form-field>

      <mat-form-field data-testid="tmt-erp-outbound-filter-modal-pnr-field">
        <mat-label data-testid="tmt-erp-outbound-filter-modal-pnr-field-label">PNR</mat-label>
        <input matInput formControlName="PNR" placeholder="e.g. ABCDEF" data-testid="tmt-erp-outbound-filter-modal-pnr-field-input"/>
      </mat-form-field>

      <mat-form-field data-testid="tmt-erp-outbound-filter-modal-erp-message-id-field">
        <mat-label data-testid="tmt-erp-outbound-filter-modal-erp-message-id-field-label">ERP Message ID</mat-label>
        <input matInput formControlName="ErpMessageId" placeholder="e.g. 00000000-0000-0000-0000-000000000000" data-testid="tmt-erp-outbound-filter-modal-erp-message-id-field-input"/>
      </mat-form-field>

      <mat-form-field data-testid="tmt-erp-outbound-filter-modal-legal-entity-field">
        <mat-label data-testid="tmt-erp-outbound-filter-modal-legal-entity-field-label">Legal Entity</mat-label>
        <mat-select formControlName="LegalEntityId" data-testid="tmt-erp-outbound-filter-modal-legal-entity-field-select">
          <mat-option [value]="null">All</mat-option>
          @for (entity of legalEntities$ | async; track entity.id) {
            <mat-option [value]="entity.id">{{ entity.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field data-testid="tmt-erp-outbound-filter-modal-queue-field">
        <mat-label data-testid="tmt-erp-outbound-filter-modal-queue-field-label">Queue</mat-label>
        <mat-select formControlName="QueueName" data-testid="tmt-erp-outbound-filter-modal-queue-field-select">
          <mat-option [value]="null">All</mat-option>
          @for (entity of legalEntities$ | async; track entity.outboundQueue) {
            <mat-option [value]="entity.outboundQueue">{{ entity.outboundQueue }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label data-testid="tmt-erp-outbound-filter-modal-response-type-field-label">Response Type</mat-label>
        <mat-select formControlName="ResponseType" data-testid="tmt-erp-outbound-filter-modal-response-type-field-select">
          <mat-option [value]="null">All</mat-option>
          @for (option of responseTypeOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field data-testid="tmt-erp-outbound-filter-modal-created-from-field">
        <mat-label data-testid="tmt-erp-outbound-filter-modal-created-from-field-label">Created From</mat-label>
        <input matInput readonly [matDatepicker]="createdFrom" formControlName="CreatedDateFrom" data-testid="tmt-erp-outbound-filter-modal-created-from-field-input"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #createdFrom/>
        <mat-datepicker-toggle matIconSuffix [for]="createdFrom"/>
      </mat-form-field>

      <mat-form-field data-testid="tmt-erp-outbound-filter-modal-created-to-field">
        <mat-label data-testid="tmt-erp-outbound-filter-modal-created-to-field-label">Created To</mat-label>
        <input matInput readonly [matDatepicker]="createdTo" formControlName="CreatedDateTo" data-testid="tmt-erp-outbound-filter-modal-created-to-field-input"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #createdTo/>
        <mat-datepicker-toggle matIconSuffix [for]="createdTo"/>
      </mat-form-field>

      <div class="radio-filter-wrapper" data-testid="tmt-erp-outbound-filter-modal-has-sales-order-number-field">
        <div class="radio-header">
          <span class="radio-label" data-testid="tmt-erp-outbound-filter-modal-has-sales-order-number-field-label">
            Has Sales Order Number?
          </span>
          <button
            id="tmt-erp-outbound-has-sales-order-number-clear-filter-button"
            mat-icon-button
            type="button"
            class="clear-icon-btn"
            style="float: right;"
            (click)="clearErpSalesOrderNumberFilter()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <mat-radio-group formControlName="HasSalesOrderNumber" aria-label="matching-mode" color="primary" class="radio-group">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="radio-filter-wrapper" data-testid="tmt-erp-outbound-filter-modal-has-sales-order-sync-queue-id-field">
        <div class="radio-header">
          <span class="radio-label" data-testid="tmt-erp-outbound-filter-modal-has-sales-order-sync-queue-id-field-label">
            Has Sync Queue ID?
          </span>
          <button
            id="tmt-erp-outbound-has-sales-order-sync-queue-id-clear-filter-button"
            mat-icon-button
            type="button"
            class="clear-icon-btn"
            style="float: right;"
            (click)="clearSalesOrderSyncQueueIdFilter()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <mat-radio-group formControlName="HasSalesOrderSyncQueueId" aria-label="matching-mode" color="primary" class="radio-group">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-form-field data-testid="tmt-erp-outbound-filter-modal-result-field">
        <mat-label data-testid="tmt-erp-outbound-filter-modal-result-field-label">Result</mat-label>
        <mat-select formControlName="Result" data-testid="tmt-erp-outbound-filter-modal-result-field-select">
          <mat-option [value]="null">All</mat-option>
          @for (option of resultOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <ng-container modalPanelFooter>
    <button mat-button (click)="reset()">Reset</button>
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
  </ng-container>
</modal-panel>
